"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var nanoid = require("nanoid");
function createTask(task) {
    return __assign({}, task, { createdAt: Date.now(), id: nanoid(), spentSeconds: 0, updatedAt: Date.now() });
}
exports.createTask = createTask;
function extractTagsFromTasks(tasks) {
    return _.uniq(_.flatMap(tasks, function (_a) {
        var tags = _a.tags;
        return tags;
    })).sort();
}
exports.extractTagsFromTasks = extractTagsFromTasks;
//# sourceMappingURL=task.js.map


//////////////////
// WEBPACK FOOTER
// ./local_modules/common/domain/task.js
// module id = 601
// module chunks = 0